const fileExtension = {
    csv: 'csv',
    json: 'json',
    xml: 'xml',
    txt: 'txt'
};

export default fileExtension;